// src/App.jsx
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./App.css";

/* صفحاتك */
import Home from "./components/page/home";

function Shell({ children }) {
  return (
    <div className=" bg-gradient-to-b from-light-blue-100 via-light-blue-50 to-light-blue-100">
      <div>{children}</div>
    </div>
  );
}

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const dispatch = useDispatch();

  const checkSession = () => {
    const token = localStorage.getItem("token");
    const tokenExpiration = localStorage.getItem("tokenExpiration");
    if (token && tokenExpiration && Date.now() < Number(tokenExpiration)) {
      setIsLoggedIn(true);
      return;
    }
    setIsLoggedIn(false);
  };

  useEffect(() => {
    checkSession();
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        {/* صفحة العرض /brand متاحة للجميع وخارج أي غلاف */}
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
